import React from 'react';
import classnames from 'classnames';
import { StatusTip, LoadingTipProps } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface LoadingProps extends IBaseProps, LoadingTipProps {
  innerStyle?: React.CSSProperties;
  loading?: boolean;
  loadingBg?: string;
}

const Loading: React.ForwardRefRenderFunction<HTMLDivElement, LoadingProps> = (props, ref) => {
  const {
    style,
    className,
    loading,
    innerStyle = {},
    loadingText = 'Loading...',
    loadingBg,
    children,
    ...restProps
  } = props;

  return (
    <div ref={ref} style={style} className={classnames('dbg-common-loading', className)}>
      {loading ? (
        <div
          className="dbg-common-loading-wraps"
          style={{ ...innerStyle, backgroundColor: loadingBg || 'transparent' }}
        >
          <StatusTip.LoadingTip loadingText={loadingText} {...restProps} />
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default React.forwardRef(Loading);
